<template>
  <div>
    <XVbootstraprow
      :label="translation(4913)"
      :helptext="translation(923)"
      :haserror="errors.has('OrgNaam')"
      :errormessage="errors.first('OrgNaam')"
      :required="true"
      veldID="OrgNaam"
    >
      <XVinput
        id="OrgNaam"
        name="OrgNaam"
        :value="value.tblExternalOrganizationName"
        @input="updateField('tblExternalOrganizationName', $event)"
        v-validate="SchemaCheckName()"
        data-vv-validate-on="blur"
        :data-vv-as="translation(4913)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(4914)"
      :helptext="translation(924)"
      :haserror="errors.has('BezoekAdres')"
      :errormessage="errors.first('BezoekAdres')"
      :required="true"
    >
      <XVtextarea
        id="BezoekAdres"
        name="BezoekAdres"
        :value="value.tblExternalOrganizationVisitAddress"
        @input="updateField('tblExternalOrganizationVisitAddress', $event)"
        v-validate="'required'"
        :data-vv-as="translation(4914)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(35)"
      :haserror="errors.has('Postcode')"
      :errormessage="errors.first('Postcode')"
      :required="true"
    >
      <XVinput
        id="Postcode"
        name="Postcode"
        :value="value.tblExternalOrganizationVisitAddressPostCode"
        @input="updateField('tblExternalOrganizationVisitAddressPostCode', $event)"
        v-validate="'required'"
        :data-vv-as="translation(35)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(36)"
      :haserror="errors.has('Plaats')"
      :errormessage="errors.first('Plaats')"
      :required="true"
    >
      <XVinput
        id="Plaats"
        name="Plaats"
        :value="value.tblExternalOrganizationVisitAddressCity"
        @input="updateField('tblExternalOrganizationVisitAddressCity', $event)"
        v-validate="'required'"
        :data-vv-as="translation(36)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(117)"
      :helptext="translation(2061)"
      :haserror="errors.has('PostAdres')"
      :errormessage="errors.first('PostAdres')"
    >
      <XVtextarea
        id="PostAdres"
        name="PostAdres"
        :value="value.tblExternalOrganizationPostalAddress"
        @input="updateField('tblExternalOrganizationPostalAddress', $event)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(35)"
      :haserror="errors.has('PostAdresPostcode')"
      :errormessage="errors.first('PostAdresPostcode')"
    >
      <XVinput
        id="PostAdresPostcode"
        name="PostAdresPostcode"
        :value="value.tblExternalOrganizationPostalAddressPostCode"
        @input="updateField('tblExternalOrganizationPostalAddressPostCode', $event)"
        :formatter="formatPostcode"
        :data-vv-as="translation(35)"
      />
    </XVbootstraprow>
    <XVbootstraprow :label="translation(36)">
      <XVinput
        id="PostAdresPlaats"
        name="PostAdresPlaats"
        :value="value.tblExternalOrganizationPostalAddressCity"
        @input="updateField('tblExternalOrganizationPostalAddressCity', $event)"
      />
    </XVbootstraprow>
    <XVbootstraprow
      :label="translation(118)"
      :helptext="translation(925)"
      :haserror="errors.has('Land')"
      :errormessage="errors.first('Land')"
      :required="true"
    >
      <multiselect
        id="Land"
        name="Land"
        :value="selectedCountry"
        @input="updateField('tblCountryID', $event.tblCountryID)"
        :options="countries"
        v-validate="'required'"
        :allow-empty="false"
        :data-vv-as="translation(118)"
        track-by="tblCountryID"
        label="landnaam"
        class="f32"
        placeholder="Kies een land"
        selectLabel
      >
        <!-- gebruikt voor de vlaggen https://github.com/lafeber/world-flags-sprite -->
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <!-- <span>{{emojiFlags(props.option.tblCountryCode).unicode}}</span> -->
            <span :class="'flag ' + props.option.tblCountryCode.toLowerCase()"></span>
            <span class="option__title">{{ props.option.landnaam }}</span>
          </span>
        </template>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <!-- <span>{{emojiFlags(props.option.tblCountryCode).unicode}}</span> -->
            <span :class="'flag ' + props.option.tblCountryCode.toLowerCase()"></span>
            <span class="option__title">{{ props.option.landnaam }}</span>
          </div>
        </template>
        <span slot="noResult">{{ translation(14508) }}</span>
      </multiselect>
    </XVbootstraprow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FAMixin, util } from 'pevueglobal'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [FAMixin],
  inject: ['$validator'],
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    profgroupID: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapGetters('extOrgDetailsForm', ['countries']),
    selectedCountry() {
      return this.$store.state.extOrgDetailsForm.countries.find(c => c.tblCountryID === this.value.tblCountryID)
    }
  },
  mounted() {
    this.getTexten()
    this.initCountries()
  },
  methods: {
    ...mapActions('extOrgDetailsForm', ['getTexten', 'initCountries']),
    updateField(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    formatPostcode(value, event) {
      return value.replace(' ', '').toUpperCase()
    },
    SchemaCheckName() {
      util.isLoggedIn().then((loggedIn) => {
        return {
          required: true,
          customServerValidate: {
            validatorApiRoute: `${loggedIn ? 'allroles' : 'public'}/PEapi_CheckExtOrgNameIsUnique`,
            parameters: this.profgroupID ? { SES_bergrpid: this.profgroupID } : {}
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.flag {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
}
</style>
